<template>
    <span>
      {{date}}
    </span>
</template>

<script>
import parse from 'date-fns/parse'

export default {
  props: {
    timestamp: {
      type: String
    }
  },

  computed: {
    date: function () {
      if (this.timestamp !== null) {
        var parsed = parse(this.timestamp)
        return parsed.toLocaleString('en-US', {month: 'short', day: 'numeric', year: 'numeric'})
      } else {
        return "--"
      }
    }

  }
}
</script>
